import React from 'react'
import { Field, WatchField, useWatch } from '../../form'
import classNames from 'classnames'
import Button from '@material-ui/core/Button'
import FontAwesome from 'react-fontawesome'
import { Translation } from 'react-i18next'
import MultiSelectWithCheckboxes_expertise from '../common/areaExpertiseSelectField'
import AreaOfWorkSelectField from '../common/areaOfWorkSelectField'
import { useSelector } from 'react-redux'
import { getFormReducer } from '../../selectors/openForWork.selector'
import { useController } from 'react-hook-form'
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  IconButton
} from '@material-ui/core'
import { shrinkString } from '../../utils/openForWork.utils'
import { CloudUploadRounded } from '@mui/icons-material'
import LinkRowComponent from './linkRow.component'
import { AddCircle, RemoveCircle } from '@material-ui/icons'

/**
 * @author Huong Nguyen
 */

const InformationComponent = ({
  t,
  classes,
  control,
  setValue,
  clearErrors,
  IsNotOpenForWork,
  files,
  setFiles,
  blank_picture,
  set_blank_picture,
  areaExpertiseList,
  areaOfWorkList,
  applicationData,
  errorsValid,
  notOpenForWork,
  linkRow_fields,
  link_addRow,
  link_removeRow,
  portfolios,
  setPortfolios,
  portfolios_base64data,
  setPortfolios_base64data,
  setIsDirty
}) => {
  // const [letterFileData, setLetterFileData] = React.useState('')
  const [cvFileData, setCvFileData] = React.useState('')
  // const [portfolios, setPortfolios] = React.useState([])
  const handlePortfolioChange = (event) => {
    const selectedFiles = Array.from(event.target.files)
    const validFiles = selectedFiles.filter(
      (file) => file.type === 'image/png' || file.type === 'image/jpeg'
    )
    if (portfolios.length + validFiles.length > 5) {
      alert(t('openForWork.warn2'))
      return
    }
    setPortfolios((prevFiles) => [...prevFiles, ...validFiles])
    setIsDirty(true)
  }
  const handleRemove = (index) => {
    setPortfolios(portfolios.filter((_, i) => i !== index))
    setIsDirty(true)
  }
  //Huong - update shown picture
  const imageHandler = (e) =>
    handleFileUpload(
      e,
      1,
      null,
      files,
      setFiles,
      setValue,
      set_blank_picture,
      shrinkString,
      null,
      setIsDirty
    )
  // Upload letter file
  // const letterHandler = (e) =>
  //   handleFileUpload(
  //     e,
  //     2,
  //     'letter_file',
  //     files,
  //     setFiles,
  //     setValue,
  //     null,
  //     shrinkString,
  //     clearErrors
  //   )
  // Upload CV file
  const CVHandler = (e) =>
    handleFileUpload(
      e,
      3,
      'CV_file',
      files,
      setFiles,
      setValue,
      null,
      shrinkString,
      clearErrors,
      setIsDirty
    )

  // const input_letter_data = useWatch({
  //   fields: 'inputLetter',
  //   control: control
  // })
  const input_cv_data = useWatch({
    fields: 'inputCV',
    control: control
  })

  const allForm = useSelector(getFormReducer)
  const handeOnChange = () => {
    if (allForm?.openforwork) {
      if (allForm.openforwork.loadData.IsNotOpenForWork === false) {
        // console.log('huong call not open for work')
        notOpenForWork()
      }
    }
  }

  React.useEffect(() => {
    handlePortfoliosBase64Data(portfolios).then((data) => {
      setPortfolios_base64data(data)
    })
  }, [portfolios])

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <div className="col-xs-12 col-sm-5 col-lg-5">
              <div className="panel panel-defaulf">
                <div className="panel-heading">
                  <h3 className="panel-title">{t('openForWork.profile')}</h3>
                </div>
                <div className="panel-body">
                  <div
                    className="col-xs-12 col-sm-6 col-lg-5"
                    style={{ position: 'relative' }}
                  >
                    <div
                      className="img-holder"
                      style={{ position: 'relative' }}
                    >
                      <img
                        src={blank_picture}
                        className="img-fluid img-thumbnail"
                        style={{
                          aspectRatio: '3 / 3'
                        }}
                      />
                      {blank_picture ===
                        '../../images/blank-profile-picture.png' && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0
                            // padding: '10px' // Adjust the padding as needed
                          }}
                        >
                          <Button
                            variant="contained"
                            className={classes.buttonFile}
                            component="label"
                            htmlFor="input-image"
                            // disabled={IsNotOpenForWork === true ? true : false}
                            style={{
                              padding: '5px 10px'
                              // backgroundColor:
                              //   IsNotOpenForWork === true
                              //     ? '#f0f0f0'
                              //     : undefined
                            }}
                          >
                            {t('openForWork.button1')}
                          </Button>
                        </div>
                      )}
                    </div>
                    {blank_picture !==
                      '../../images/blank-profile-picture.png' && (
                      <div style={{ marginTop: '5px' }}>
                        <Button
                          variant="contained"
                          className={classes.buttonFile}
                          component="label"
                          htmlFor="input-image"
                          // disabled={IsNotOpenForWork === true ? true : false}
                          style={{
                            padding: '5px 10px'
                            // backgroundColor:
                            //   IsNotOpenForWork === true ? '#f0f0f0' : undefined
                          }}
                        >
                          {t('openForWork.button1')}
                        </Button>
                      </div>
                    )}
                    <div className="dashboard-tax-input">
                      <Field
                        name="inputImage"
                        inputType="file"
                        id="input-image"
                        control={control}
                        accept="image/*"
                        onChange={imageHandler}
                      />
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-lg-7">
                    <div className="row">
                      <p style={{ fontWeight: 'bold' }}>
                        {t('openForWork.profile1')}
                      </p>
                      <p style={{ color: '#808080' }}>
                        {t('openForWork.profile2')}
                      </p>
                      <p>{t('openForWork.profile3')}</p>
                      <p>{t('openForWork.profile4')}</p>
                      <p>{t('openForWork.profile5')}</p>
                    </div>
                  </div>
                  <div>
                    <Field
                      name="IsNotOpenForWork"
                      label={t('openForWork.label1')}
                      inputType="checkbox"
                      control={control}
                      className={classNames(classes.checkbox)}
                      onChange={handeOnChange}
                    />
                    <Field
                      name="notAcceptRatings"
                      label={t('openForWork.label3')}
                      inputType="checkbox"
                      control={control}
                      className={classNames(classes.checkbox)}
                      onChange={() => {
                        setIsDirty(true)
                      }}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    />
                    <Field
                      name="RetrieveJobs"
                      label={t('openForWork.label2')}
                      inputType="checkbox"
                      control={control}
                      className={classNames(classes.checkbox)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setValue('IsNotOpenForWork', false)
                        } else {
                          setValue('IsNotOpenForWork', true)
                        }
                        setIsDirty(false)
                      }}
                    />
                    <Field
                      name="info_consent_allowed"
                      label={t('openForWork.label12')}
                      inputType="checkbox"
                      control={control}
                      className={classNames(classes.checkbox)}
                      onChange={() => {
                        setIsDirty(true)
                      }}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    />
                    <Field
                      name="role_title"
                      label={t('openForWork.label13')}
                      inputType="textfield"
                      control={control}
                      className={classNames(classes.textfield)}
                      style={{ width: '70%' }}
                      onChange={() => {
                        setIsDirty(true)
                      }}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    />
                    <MultiSelectWithCheckboxes_expertise
                      control={control} // This is the control object from react-hook-form
                      name="AreaOf_Expertise"
                      label={t('openForWork.label4')}
                      className={classNames(classes.select)}
                      options={areaExpertiseList}
                      t={t}
                      setIsDirty={setIsDirty}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    />
                    <AreaOfWorkSelectField
                      control={control} // This is the control object from react-hook-form
                      name="AreaOf_Work"
                      label={t('openForWork.label5')}
                      className={classNames(classes.select)}
                      options={areaOfWorkList}
                      t={t}
                      setIsDirty={setIsDirty}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-7 col-lg-7">
              <div className="panel panel-defaulf">
                <div className="panel-heading">
                  <h3 className="panel-title">{t('openForWork.portfolio')}</h3>
                </div>
                <div className="panel-body">
                  <div>
                    <Field
                      name="short_des"
                      control={control}
                      label={t('openForWork.des')}
                      inputType="richtexteditor"
                      height="200px"
                      onChange={() => {
                        setIsDirty(true)
                      }}
                      // disabled={IsNotOpenForWork}
                    />
                  </div>
                  <div style={{ padding: '15px' }}></div>
                  <div>
                    <Table className={classes.table}>
                      <TableBody>
                        {/* <TableRow className="row-style">
                          <TableCell
                            variant="head"
                            className={classes.tableHead}
                          >
                            {t('openForWork.file1')}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            <div>
                              <div>
                                <Button
                                  variant="contained"
                                  className={classes.buttonFile}
                                  component="label"
                                  htmlFor="input-letter"
                                  disabled={
                                    IsNotOpenForWork === true ? true : false
                                  }
                                >
                                  {t('openForWork.button2')}
                                </Button>
                              </div>
                              <div className="dashboard-tax-input">
                                <FileInput
                                  name="inputLetter"
                                  inputType="file"
                                  id="input-letter"
                                  control={control}
                                  accept=".pdf, .docx, .doc"
                                  onChange={letterHandler}
                                  files={letterFileData}
                                  setFiles={setLetterFileData}
                                />
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            <div>
                              <WatchField
                                control={control}
                                fields={['inputLetter', 'letter_file']}
                              >
                                {(watch) =>
                                  watch.inputLetter === '' ||
                                  watch.letter_file === '' ? null : (
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <div>
                                        <Field
                                          name="letter_file"
                                          inputType="textfield"
                                          control={control}
                                          className={classNames(
                                            classes.textfield1
                                          )}
                                          disabled={true}
                                        />
                                      </div>
                                      
                                      {input_letter_data.inputLetter ===
                                      applicationData.inputLetter ? (
                                        <div style={{ marginRight: '5px' }}>
                                          <a href={applicationData.inputLetter}>
                                            <FontAwesome name="file-pdf-o" />
                                          </a>
                                        </div>
                                      ) : null}
                                      <div>
                                        {IsNotOpenForWork ? (
                                          <FontAwesome
                                            name="window-close"
                                            style={{ color: 'grey' }}
                                          />
                                        ) : (
                                          <FontAwesome
                                            name="window-close"
                                            style={{ color: '#F67131' }}
                                            onClick={() => {
                                              setValue('letter_file', '')
                                              setValue('inputLetter', '')
                                              setLetterFileData('')
                                              clearFileUploaded(
                                                files,
                                                setFiles,
                                                2
                                              )
                                            }}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  )
                                }
                              </WatchField>
                              {errorsValid.letter_file === 'Obligatory' ||
                              errorsValid.letter_file === 'Pakollinen' ||
                              errorsValid.letter_file === 'Kohustuslik' ? (
                                <Field
                                  name="letter_file"
                                  inputType="textfield"
                                  control={control}
                                  className={classNames(classes.textfield1)}
                                  disabled={true}
                                />
                              ) : null}
                            </div>
                          </TableCell>
                        </TableRow> */}
                        <TableRow className="row-style">
                          <TableCell
                            variant="head"
                            className={classes.tableHead}
                            colSpan={3}
                          >
                            {t('openForWork.label14')}
                          </TableCell>
                        </TableRow>
                        <TableRow className="row-style">
                          <TableCell className={classes.tableCell} colSpan={3}>
                            <div>
                              <label
                                style={{
                                  display: 'inline-block',
                                  padding: '8px 18px',
                                  background:
                                    // IsNotOpenForWork ||
                                    portfolios.length >= 5
                                      ? 'lightgrey'
                                      : '#F67131',
                                  color: 'white',
                                  borderRadius: '5px',
                                  cursor: 'pointer',
                                  marginTop: '10px'
                                }}
                              >
                                {t('openForWork.button5')}
                                <input
                                  type="file"
                                  accept="image/png, image/jpeg"
                                  multiple
                                  onChange={handlePortfolioChange}
                                  disabled={
                                    portfolios.length >= 5
                                    // || IsNotOpenForWork
                                  }
                                  style={{ display: 'none' }}
                                />
                              </label>
                              <span> {t('openForWork.note1')}</span>
                              <div
                                style={{
                                  display: 'flex',
                                  gap: '10px',
                                  marginTop: '10px',
                                  flexWrap: 'wrap',
                                  border: '1px dashed grey',
                                  borderRadius: '10px',
                                  minHeight:
                                    portfolios.length > 0 ? null : '100px'
                                }}
                              >
                                {portfolios_base64data.map((file, index) => {
                                  const previewUrl = file?.FilePath
                                    ? file?.FilePath
                                    : file.data
                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        position: 'relative'
                                      }}
                                    >
                                      <img
                                        src={previewUrl}
                                        alt="preview"
                                        width="100"
                                        height="100"
                                        style={{
                                          objectFit: 'cover',
                                          borderRadius: '5px',
                                          padding: '10px'
                                        }}
                                      />
                                      <IconButton
                                        component="span"
                                        className={classes.buttonFile}
                                        // disabled={IsNotOpenForWork}
                                        size="medium"
                                        style={{
                                          // position: 'absolute',
                                          top: '-30px',
                                          right: '10px',
                                          color: '#F67131',
                                          padding: 0
                                        }}
                                        onClick={() => handleRemove(index)}
                                      >
                                        <RemoveCircle fontSize="large" />
                                      </IconButton>
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow className="row-style">
                          <TableCell
                            variant="head"
                            className={classes.tableHead}
                            colSpan={3}
                          >
                            {t('openForWork.file2')}
                          </TableCell>
                        </TableRow>
                        <TableRow className="row-style">
                          {/* <TableCell className={classes.tableCell}></TableCell> */}
                          <TableCell className={classes.tableCell} colSpan={3}>
                            <div style={{ display: 'flex' }}>
                              <div>
                                <div>
                                  {/* <Button
                                  variant="contained"
                                  className={classes.buttonFile}
                                  component="label"
                                  htmlFor="input-cv"
                                  disabled={
                                    IsNotOpenForWork === true ? true : false
                                  }
                                >
                                  {t('openForWork.button2')}
                                </Button> */}
                                  <label htmlFor={'input-cv'}>
                                    <IconButton
                                      component="span"
                                      className={classes.buttonFile}
                                      // disabled={IsNotOpenForWork}
                                      size="medium"
                                      style={{
                                        color: '#F67131'
                                      }}
                                    >
                                      <CloudUploadRounded fontSize="large" />
                                    </IconButton>
                                  </label>
                                </div>
                                <div className="dashboard-tax-input">
                                  <FileInput
                                    name="inputCV"
                                    inputType="file"
                                    id="input-cv"
                                    control={control}
                                    accept=".pdf, .docx, .doc"
                                    onChange={CVHandler}
                                    files={cvFileData}
                                    setFiles={setCvFileData}
                                  />
                                </div>
                              </div>
                              <div>
                                <WatchField
                                  control={control}
                                  fields={['inputCV', 'CV_file']}
                                >
                                  {(watch) =>
                                    watch.inputCV === '' ||
                                    watch.CV_file === '' ? null : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center'
                                        }}
                                      >
                                        <div style={{ marginRight: '10px' }}>
                                          <Field
                                            name="CV_file"
                                            inputType="textfield"
                                            control={control}
                                            className={classNames(
                                              classes.textfield1
                                            )}
                                            disabled={true}
                                          />
                                        </div>
                                        {/* download CV */}
                                        {input_cv_data.inputCV ===
                                        applicationData.inputCV ? (
                                          <div style={{ marginRight: '10px' }}>
                                            <a href={applicationData.inputCV}>
                                              <FontAwesome name="file-pdf-o" />
                                            </a>
                                          </div>
                                        ) : null}
                                        <div>
                                          {/* {IsNotOpenForWork ? (
                                            <FontAwesome
                                              name="window-close"
                                              style={{ color: 'grey' }}
                                            />
                                          ) : ( */}
                                          <FontAwesome
                                            name="window-close"
                                            style={{ color: '#F67131' }}
                                            onClick={() => {
                                              setValue('CV_file', '')
                                              setValue('inputCV', '')
                                              setIsDirty(true) // Use this to check if any data of form is changed
                                              setCvFileData('')
                                              clearFileUploaded(
                                                files,
                                                setFiles,
                                                3
                                              )
                                            }}
                                          />
                                          {/* )} */}
                                        </div>
                                      </div>
                                    )
                                  }
                                </WatchField>
                                {errorsValid.CV_file === 'Obligatory' ||
                                errorsValid.CV_file === 'Pakollinen' ||
                                errorsValid.CV_file === 'Kohustuslik' ? (
                                  <Field
                                    name="CV_file"
                                    inputType="textfield"
                                    control={control}
                                    className={classNames(classes.textfield1)}
                                    disabled={true}
                                  />
                                ) : null}
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow className="row-style">
                          <TableCell
                            variant="head"
                            className={classes.tableHead}
                            colSpan={3}
                          >
                            {t('openForWork.label11')}
                          </TableCell>
                        </TableRow>
                        {/* <TableCell
                            variant="head"
                            style={{ width: '30%', paddingBottom: '9px' }}
                            className={classes.tableHead}
                          >
                            {t('openForWork.label11')}
                          </TableCell>
                          <TableCell
                            colSpan={2}
                            className={classes.tableCell}
                            style={{ paddingBottom: '9px' }}
                          >
                            <Field
                              name="linkedin_url"
                              label={t('')}
                              inputType="textfield"
                              control={control}
                              className={classNames(classes.textfield2)}
                              disabled={
                                IsNotOpenForWork === true ? true : false
                              }
                              disableUnderline={true}
                              multiline
                            />
                          </TableCell> */}
                        {getLinkRows(
                          t,
                          classes,
                          control,
                          linkRow_fields,
                          link_removeRow,
                          IsNotOpenForWork,
                          setIsDirty
                        )}
                        <TableRow className="row-style">
                          <TableCell className={classes.tableCell} colSpan={3}>
                            <div className="pull-right">
                              <IconButton
                                component="span"
                                className={classes.buttonFile}
                                // disabled={IsNotOpenForWork}
                                size="medium"
                                style={{
                                  color: '#F67131'
                                }}
                                onClick={link_addRow}
                              >
                                <AddCircle fontSize="large" />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const getLinkRows = (
  t,
  classes,
  control,
  fields,
  link_removeRow,
  IsNotOpenForWork,
  setIsDirty
) =>
  fields.map((el, index) => (
    <LinkRowComponent
      index={index}
      key={el.id}
      link_removeRow={link_removeRow}
      t={t}
      classes={classes}
      control={control}
      IsNotOpenForWork={IsNotOpenForWork}
      link_title={`linkRow.${index}.link_title`}
      link_url={`linkRow.${index}.link_url`}
      setIsDirty={setIsDirty}
    />
  ))

const handleFileUpload = (
  e,
  attachmentType,
  setValueField,
  files,
  setFiles,
  setValue,
  set_blank_picture,
  shrinkString,
  clearErrors,
  setIsDirty
) => {
  e.preventDefault()
  const reader = new FileReader()
  const file = e.target.files[0]

  if (file !== undefined) {
    if (setValueField) {
      setValue(
        setValueField,
        shrinkString(e.target.value.split('\\').slice(-1).pop(), 20, 10)
      )
      clearErrors(setValueField)
    }
    reader.onload = () => {
      if (reader.readyState === 2 && attachmentType === 1) {
        set_blank_picture(reader.result)
      }
      const newState = files.map((obj) => {
        if (obj.AttachmentType === attachmentType) {
          return {
            AttachmentType: attachmentType,
            Title: file.name,
            FileType: file.type,
            data: reader.result
          }
        } else {
          return obj
        }
      })
      setFiles(newState)
      setIsDirty(true)
    }
    reader.readAsDataURL(file)
  }
}

const handlePortfoliosBase64Data = async (portfolios) => {
  const readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => resolve(e.target.result) // File content as base64
      reader.onerror = (error) => reject(error)
      reader.readAsDataURL(file)
    })
  }

  const filesWithData = await Promise.all(
    portfolios.map(async (file) => {
      // Check if the object is already structured correctly
      if (file?.FilePath) {
        return file // Return as is if already structured
      }

      // Otherwise, transform to the desired structure
      return {
        AttachmentType: 4,
        Title: file.name,
        FileType: file.type,
        data: await readFile(file)
      }
    })
  )

  return filesWithData
}

const clearFileUploaded = (files, setFiles, attachmentType) => {
  const newState = files.map((obj) => {
    if (obj.AttachmentType === attachmentType) {
      return {
        AttachmentType: attachmentType,
        Title: null,
        FileType: null,
        data: null
      }
    } else {
      return obj
    }
  })
  setFiles(newState)
}

const FileInput = (props) => {
  const { name, id, accept, control, onChange, files, setFiles } = props

  const { field } = useController({ name, control })

  function handleChange(e) {
    onChange?.(e)
    setFiles(e.target.value)
    field.onChange(e.target.files)
  }

  return (
    <input
      type="file"
      id={id}
      accept={accept ? accept : undefined}
      value={files}
      onChange={handleChange}
      onBlur={field.onBlur}
      ref={field.ref}
    />
  )
}

export default InformationComponent
